
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`Selon des
`}<a parentName="p" {...{
        "href": "https://ir.novavax.com/Complete-PREVENT-19-Phase-3-Clinical-Trial-Results-Manuscript-for-COVID-19-Vaccine-Posted-to-medRxiv"
      }}>{`résultats préliminaires de phase III`}</a>{`,
l'efficacité est de 90,4%. Ce test a été mené sur près de 30'000 adultes aux
Etats-Unis et au Mexique entre le 27 décembre 2020 et le 18 février 2021. Ces
données ont été publiées dans la revue
`}<a parentName="p" {...{
        "href": "https://www.medrxiv.org/content/10.1101/2021.10.05.21264567v1"
      }}>{`"medRxiv"`}</a>{` le 10
octobre 2021 et doivent encore être analysées par les pairs.`}</p>
    <p>{`Des volontaires dès l'âge de 12 ans ont été intégrés aux essais cliniques en
mai 2021.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;